import { Component, Input, ViewChild, ElementRef, AfterContentChecked, AfterViewInit, OnDestroy, AfterViewChecked } from '@angular/core';
import { CSSMonitorService } from '../services/css-monitor.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $:any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const bootstrap: any;
/**
 * This class represents the toolbar component.
 */
@Component({
    selector: 'tooltip',
    templateUrl: 'tooltip.component.html',
    standalone: false
})

export class TooltipComponent implements AfterContentChecked, AfterViewChecked, OnDestroy {

    @ViewChild('ttButton') el:ElementRef;

    @Input('tooltip-text')
    ttText:string;
    private currentLang: string;

    private subscription: Subscription = null;

    constructor(
        private translate: TranslateService,
        private cssMonitorService: CSSMonitorService
    ) {}

    ngAfterViewChecked(): void {
        if (this.currentLang !== this.translate.currentLang) {
            this.translate.get(this.ttText).subscribe((res:string) => {
                $(this.el.nativeElement).attr('data-bs-content', res);

                // With Bootstrap 5 above by itself wasn't working.
                // Don't know why the create isntance with Bootstrap wasnt working
                const mypopover =  
                    bootstrap.Popover.getOrCreateInstance(this.el.nativeElement);
                mypopover.setContent({
                  '.popover-body': res
                });

                $(this.el.nativeElement).attr('aria-label', res);
            });
            this.currentLang = this.translate.currentLang;
        }
        $(this.el.nativeElement).popover();
    }

    ngAfterContentChecked() {
        this.cssMonitorService.start();
        this.subscription = this.cssMonitorService.styleChangeEvent.subscribe(
            (gotCss:string) => {
                if (gotCss === this.cssMonitorService.CSS_DISABLED) {
                    this.handleCSSDisabled();
                } else {
                    this.handleCSSEnabled();
                }
            }
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    protected handleCSSDisabled() {

    }

    protected handleCSSEnabled() {
        
    }
}
